module.exports = __webpack_public_path__ + "static/media/Slots-banner.75f3db22.png";